module.exports = __webpack_public_path__ + "fk.6f0123db58790a17cb04.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/fk.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/fk.svg
// module chunks = styles